import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  public show: boolean = true;

  constructor(@Inject(DOCUMENT) private dom: Document) {

  }

  ngOnInit() {
    setTimeout(() => {
      this.show = false;
      this.dom.querySelector(".hide-stuff").classList.remove("hide-stuff");
    }, 600);
  }

}
